<template>
  <navBack></navBack>
  <div class="page">
    <customer-bar :customer="customer" @do-click="goSearchCustomer"></customer-bar>

    <div class="section">
      <div class="headBar flexBar">
        <div class="title">快速充值</div>
      </div>

      <div class="rechargeList">
        <div class="swipe-container">
          <div class="wrapTopScroll">
            <div 
              v-for="(item, index) in activeList" 
              :key="index"
              class="rechargeItem" 
              @click="choseThisActive(index)"
            >
              <div class="firstBar">充￥{{ item.investAmount }}</div>
              <div class="secondBar">赠￥{{ item.zengAmount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <t-input 
        label="充值金额" 
        align="right" 
        type="number" 
        v-model="investAmount" 
        placeholder="请输入充值金额"
        @change="doChangeRechargeAmount"
      />

      <t-input 
        label="赠送金额" 
        align="right" 
        type="number" 
        v-model="zengAmount" 
        placeholder="请输入赠送金额"
      />
    </div>

    <div class="section">
      <t-cell title="付款金额" :note="`¥${investAmount}`" />
      <t-cell 
        title="业务员" 
        hover 
        arrow 
        :note="seller.name" 
        @click="showServiceDialog = true" 
      />
      <t-cell 
        title="付款方式" 
        hover 
        arrow 
        :note="payType.name || '请选择付款方式'" 
        @click="showPayTypeSheet = true" 
      />
    </div>

    <div class="confirmBar">
      <t-button 
        :disabled="isLoading" 
        theme="primary" 
        @click="doSubmitOrder"
        size="large"
      >
        充值
        <span v-if="investAmount > 0">¥{{ investAmount }}</span>
      </t-button>
    </div>

    <t-action-sheet 
      v-model:visible="showPayTypeSheet" 
      :items="payTypeSheetItems" 
      @selected="handlePayTypeSelected"
      @cancel="showPayTypeSheet = false" 
    />

    <t-dialog 
      v-model:visible="showSuccessDialog"
      title="充值成功"
      :confirm-btn="{
        content: '确定',
        variant: 'text'
      }"
      @confirm="handleDialogConfirm"
      @close="handleDialogClose"
    >
      <template #footer>
        <div class="dialog-footer">
          <t-button theme="primary" variant="text" @click="handleDialogConfirm">
            确定
          </t-button>
        </div>
      </template>
    </t-dialog>

    <t-popup 
      v-model:visible="showServiceDialog" 
      placement="bottom" 
      destroy-on-close
    >
      <choseServiceLite 
        order-type="4" 
        @closeDialog="showServiceDialog = false" 
        @confirm="confirmService"
      />
    </t-popup>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { Toast } from 'tdesign-mobile-vue'
import Decimal from 'decimal'
import customerBar from '@/components/customer-bar.vue'
import choseServiceLite from '@/components/chose-service-lite.vue'
import { stateCustomer, stateShop, stateUser,stateReloadCustomer } from '@/store'
import { getTimeBag, formatTimeSN } from '@/utils.js'
import navBack  from '@/components/nav-back-top.vue'
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase
const router = useRouter()

// 响应式数据
const customer = reactive({
  name: '',
  mobile: ''
})

const showPayTypeSheet = ref(false)
const showServiceDialog = ref(false)
const showSuccessDialog = ref(false)
const isLoading = ref(false)

const seller = reactive({
  name: '请选择业务员'
})

const payType = reactive({
  name: '请选择付款方式'
})

const commission = reactive({
  name: '',
  commissionAmount: ''
})

const payTypeSheetItems = ref([
  { label: '微信', value: 'wepay', name: '微信' },
  { label: '支付宝', value: 'alipay', name: '支付宝' },
  { label: '现金', value: 'cash', name: '现金' }
])

const activeList = ref([])
const investAmount = ref(0)
const zengAmount = ref(0)

// 选择充值选项
const choseThisActive = (index) => {
  const item = activeList.value[index]
  investAmount.value = item.investAmount
  zengAmount.value = item.zengAmount
}

// 充值金额变更
const doChangeRechargeAmount = (value) => {
  investAmount.value = value
}

// 跳转到选择客户页面
const goSearchCustomer = () => {
  router.push('/searchCustomer')
}

// 确认选择业务员
const confirmService = (result) => {
  Object.assign(seller, result.seller)
  Object.assign(commission, result.commission)
  showServiceDialog.value = false
}

// 处理付款方式选择
const handlePayTypeSelected = (item) => {
  Object.assign(payType, item)
  showPayTypeSheet.value = false
}

// 处理对话框确认
const handleDialogConfirm = () => {
  showSuccessDialog.value = false
  router.back()
}

// 处理对话框关闭
const handleDialogClose = () => {
  showSuccessDialog.value = false
}

// 获取订单号
const getOrderNo = async () => {
  try {
    const db = app.database()
    const timeBag = getTimeBag()

    const orderCountRes = await db.collection("my_order").where({
      "createAt.time3": timeBag.time3,
      shopId: stateShop._id
    }).count()

    const orderCount = orderCountRes.total
    let orderNo = formatTimeSN() * 10000 + orderCount + 1
    return "XS" + orderNo
  } catch (error) {
    console.error('获取订单号失败:', error)
    throw error
  }
}

// 计算提成
const calculateTiCheng = () => {
  let tichengAmount = 0
  if (commission._id) {
    tichengAmount = new Decimal(investAmount.value || 0)
      .mul(commission.commissionValue || 0)
      .toNumber()
  }

  return {
    totalTiChengAmount: tichengAmount,
    tichengSummary: [{
      productType: 3,
      _id: 'recharge',
      productName: `储值`,
      categoryId: '',
      ticheng: seller._id ? [{
        tichengAmount,
        commission,
        role: seller.role,
        _id: seller._id,
        name: seller.name,
        yejiAmount: new Decimal(investAmount.value || 0).mul(100).toNumber(),
      }] : []
    }]
  }
}

// 提交充值订单
const doSubmitOrder = async () => {
  if (!customer._id) {
    Toast({ message: '请选择客户' })
    return
  }

  if (!investAmount.value) {
    Toast({ message: '请录入充值金额' })
    return
  }

  if (!payType.value) {
    showPayTypeSheet.value = true
    return
  }

  isLoading.value = true
  
  try {
    const _investAmount = new Decimal(investAmount.value).mul(100).toNumber()
    const totalPrice = _investAmount
    const totalPay = _investAmount
    const sumPrice = _investAmount
    const zengAmountValue = new Decimal(zengAmount.value).mul(100).toNumber()
    
    const tichengBag = calculateTiCheng()
    const orderNo = await getOrderNo()
    
    payType.amount = Number(totalPrice)

    const _data = {
      customer,
      investAmount: _investAmount,
      zengAmount: zengAmountValue,
      beizhu: '',
      createAt: getTimeBag(),
      totalPrice,
      realPay: totalPrice,
      ...tichengBag,
      operator: stateUser,
      totalPay,
      seller,
      payType: [payType],
      payWay: payType.value,
      orderNo,
      sumPrice,
      shopId: stateShop._id,
    }

    await app.callFunction({
      name: 'my_confirm_order',
      data: {
        op: 'recharge',
        ..._data
      }
    })
    
    await loadCustomerInfo(customer._id)
    showSuccessDialog.value = true;
    stateReloadCustomer.value = true
  } catch (error) {
    console.error('充值失败:', error)
    Toast({ message: '操作失败' })
  } finally {
    isLoading.value = false
  }
}

// 加载活动列表
const loadActiveList = () => {
  const db = app.database()
  const queryData = {
    type: 5,
    deleted: 0,
    shopId: stateShop._id
  }

  db.collection("my_active").where(queryData).get().then(res => {
    activeList.value = res.data
  })
}

// 加载客户信息
const loadCustomerInfo = async (customerId) => {
  const db = app.database()
  try {
    const res = await db.collection("my_customer").doc(customerId)
      .field({ 
        _id: true, 
        name: true, 
        mobile: true, 
        storeAmount: true, 
        zengAmount: true, 
        point: true, 
        sum: true 
      })
      .get()
    
    Object.assign(customer, res.data[0])
  } catch (error) {
    console.error('加载客户信息失败:', error)
  }
}

// 初始化数据
onMounted(() => {
  Object.assign(customer, stateCustomer)
  loadActiveList()
})
</script>

<style scoped>
.page {

  padding-bottom: 5vw;
}

.section {
  background-color: #fff;
  margin-bottom: 2vw;
  padding: 0 0;
}

.headBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2vw 2vw;
  border-bottom: 0.5px solid #eee;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
}

.rechargeList {
  padding: 2vw 0;
}

.swipe-container {
  width: 100%;
}

.wrapTopScroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 2vw 0;
}

.wrapTopScroll::-webkit-scrollbar {
  display: none;
}

.rechargeItem {
  flex: 0 0 20vw;
  background-color: #f5f5f5;
  border-radius: 1vw;
  padding: 3vw 2vw;
  margin-right: 5vw;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.rechargeItem:first-child {
  margin-left: 3vw;
}

.rechargeItem:last-child {
  margin-right: 3vw;
}

.rechargeItem:hover {
  background-color: #e0e0e0;
}

.firstBar {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 1vw;
  font-weight: 500;
}

.secondBar {
  font-size: 1rem;
  color: #666;
}

.confirmBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vw;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -1px 34px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 5vw;
}
</style>